import Tabs from './Tabs/'
import Collapse from './Collapse/'
import Collumns from './Collumns'

export default {
  Collumns,
  Tabs,
  Collapse
}
